import {
  deleteTaxApi,
  taxListApi,
  createTax,
  taxTemplate,
  taxInfoByid,
  taxUpdate,
  addJurisdiction,
  getTaxRegion,
  removeTaxRegion,
} from "@/http/taxmap";

export default {
  namespaced: true,
  state: {
    taxList: [],
    taxTemplate: {},
    taxInfo: {},
    taxRegionList: []
  },
  actions: {
    async fetchTaxList({ commit }) {
      try {
        const res = await taxListApi();
        commit("SET_TAX_LIST", res.data);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createTaxAction(_, payload) {
      try {
        return await createTax(payload);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async addJurisdictionAction(_, payload) {
      const resp = await addJurisdiction(payload);
      return resp;
    },
    async getTaxRegionAction({ commit }, id) {
      const resp = await getTaxRegion(id);
      commit("TAX_REGION_LIST", resp.data);
      return resp;
    },
    async removeTaxRegionAction(_, id) {
      const resp = await removeTaxRegion(id);
      return resp;
    },
    async deleteTax({ commit }, id) {
      try {
        let res = await deleteTaxApi(id);
        commit("RESET_TAX_LIST", id);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async fetchTaxTemplate({ commit }) {
      try {
        let res = await taxTemplate();
        commit("SET_TAX_TEMPLATE", res.data);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async fetchTaxInfoById({ commit }, id) {
      try {
        let res = await taxInfoByid(id);
        commit("SET_TAX_INFO", res.data);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateTaxAction(_, { data, id }) {
      try {
        return await taxUpdate(data, id);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mutations: {
    SET_TAX_TEMPLATE(state, payload) {
      state.taxTemplate = payload;
    },
    SET_TAX_INFO(state, payload) {
      state.taxInfo = payload;
    },
    SET_TAX_LIST(state, payload) {
      state.taxList = payload;
    },
    RESET_TAX_LIST(state, payload) {
      state.taxList = state.taxList.filter((el) => el.id !== payload);
    },
    TAX_REGION_LIST(state, payload) {
      state.taxRegionList = payload;
    },
  },
};
